import { useLoaderData, useParams } from "react-router-dom";
import Logo from "../../assets/logo-2MAX-large.png";
import CommonFooter from "../../components/CommonFooter";
import { PremiumSponsorshipPreview } from "../../services/premiumSponsorship/premiumSponsorshipModel";
import PremiumSponsorshipConsentScreen from "./PremiumSponsorshipConsentScreen";

const PremiumSponsorshipConsentPage = () => {
  const { token } = useParams();
  const { sponsorship } = useLoaderData() as {
    sponsorship: PremiumSponsorshipPreview;
  };

  return (
    <div className="auth-screen">
      <img src={Logo} alt="2 Minutes Max" className="logo" />
      <div className="auth-card --wide--s">
        <div className="card_body">
          <PremiumSponsorshipConsentScreen
            token={token!}
            sponsorship={sponsorship}
          />
        </div>
      </div>
      <CommonFooter />
    </div>
  );
};

export default PremiumSponsorshipConsentPage;
